import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetMessagesLogRequest,
  GetMessagesLogResponse,
  GetQRRequest,
  GetQRResponse,
  GetWaSettingsRequest,
  GetWaSettingsResponse,
  GlobalWhatsAppContactsRequest,
  GlobalWhatsAppContactsResponse,
  LogoutRequest,
  LogoutResponse,
  SendMessageRequest,
  SendMessageResponse,
} from "../../models/WhatsApp.model";
const API_BASE_URL = environment.apiUrl;

export const SendMessage = createAsyncThunk<
  SendMessageResponse,
  SendMessageRequest,
  { rejectValue: string }
>("whatsapp/SendMessage", async (requestData, { rejectWithValue }) => {
  try {
    // תמיד שולח FormData, גם בלי קובץ
    const formData = new FormData();
    formData.append("Token", requestData.token ?? "");
    formData.append("CompanyKey", requestData.companyKey ?? "");
    formData.append("Message", requestData.message ?? "");
    formData.append("PhoneNumber", requestData.phoneNumber ?? "");
    if (requestData.mediaUrl) formData.append("MediaUrl", requestData.mediaUrl);
    if (requestData.mediaFileName) formData.append("MediaFileName", requestData.mediaFileName);
    if (requestData.media) formData.append("Media", requestData.media);
    if (requestData.mediaType)
      formData.append("MediaType", requestData.mediaType);

    const response = await fetch(`${API_BASE_URL}WhatsApp/SendMessage`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: SendMessageResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to send text message");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const GetMessagesLog = createAsyncThunk<
  GetMessagesLogResponse,
  GetMessagesLogRequest,
  { rejectValue: string }
>("whatsapp/GetMessagesLog", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}WhatsApp/GetMessagesLog`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetMessagesLogResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch messages log");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const globalWhatsAppContacts = createAsyncThunk<
  GlobalWhatsAppContactsResponse,
  GlobalWhatsAppContactsRequest,
  { rejectValue: string }
>("whatsapp/GlobalWhatsAppContacts", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}WhatsApp/GlobalWhatsAppContacts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GlobalWhatsAppContactsResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch messages log");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error",
    );
  }
});

export const getWaSettings = createAsyncThunk<
  GetWaSettingsResponse,
  GetWaSettingsRequest,
  { rejectValue: string }
>(
  "whatsapp/GetWaSettings",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}WhatsApp/GetWaSettings`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetWaSettingsResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to fetch messages log");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

export const logoutWhatsApp = createAsyncThunk<
  LogoutResponse,
  LogoutRequest,
  { rejectValue: string }
>(
  "whatsapp/Logout",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}WhatsApp/Logout`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: LogoutResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to logout");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

export const getQRCode = createAsyncThunk<
  GetQRResponse,
  GetQRRequest,
  { rejectValue: string }
>(
  "whatsapp/GetQR",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}WhatsApp/GetQR`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetQRResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to get QR code");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
